import React, { useEffect, useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import empApi from "../../lib/empApi";

export default function EmpKPI() {
  const [d, setD] = useState(null);
  useEffect(() => { empApi.get("/employee/kpi").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <div className="flex h-64 items-center justify-center"><Loader2 className="animate-spin text-amber-400" /></div>;

  const tone = d.score >= 85 ? "text-emerald-400" : d.score >= 70 ? "text-amber-400" : "text-red-400";

  return (
    <div className="space-y-4" data-testid="emp-kpi-page">
      <h2 className="font-heading text-lg font-bold text-white">KPI Saya</h2>

      <div className="rounded-2xl border border-slate-800 bg-gradient-to-br from-slate-800/60 to-indigo-900/30 p-6 text-center" data-testid="emp-kpi-score">
        <p className="text-xs uppercase tracking-wide text-slate-400">Skor KPI Bulan Ini</p>
        <p className={`font-heading text-5xl font-extrabold ${tone}`}>{d.score}</p>
        <p className="text-sm text-slate-400">dari 100</p>
        {d.bonus_eligible && (
          <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-3 py-1 text-xs font-bold text-emerald-300" data-testid="emp-kpi-bonus">
            <Sparkles size={12} /> Layak Bonus
          </span>
        )}
      </div>

      <div className="space-y-3" data-testid="emp-kpi-metrics">
        {d.metrics.map((m) => (
          <div key={m.key} className="rounded-xl border border-slate-800 bg-slate-800/40 p-3.5">
            <div className="mb-1.5 flex items-center justify-between">
              <span className="text-sm font-semibold text-white">{m.label}</span>
              <span className="flex items-center gap-2 text-xs">
                <span className={`rounded px-1.5 py-0.5 ${m.type === "auto" ? "bg-blue-500/15 text-blue-300" : "bg-purple-500/15 text-purple-300"}`}>{m.type === "auto" ? "Otomatis" : "Manual"}</span>
                <span className="font-bold text-white">{m.achievement_pct}%</span>
              </span>
            </div>
            <div className="h-2 w-full rounded-full bg-slate-700">
              <div className={`h-2 rounded-full ${m.achievement_pct >= 100 ? "bg-emerald-400" : m.achievement_pct >= 70 ? "bg-amber-400" : "bg-red-400"}`} style={{ width: `${Math.min(100, m.achievement_pct)}%` }} />
            </div>
            <div className="mt-1 flex justify-between text-[11px] text-slate-400">
              <span>Aktual: {m.filled ? `${m.actual}${m.unit}` : "—"}</span>
              <span>Target: {m.target}{m.unit} · Bobot {m.weight}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
